// 抽奖转盘模块状态管理

import { createWithEqualityFn } from "zustand/traditional";
import { consola } from "consola";
import type { WheelConfig } from "../types";
import { wheelApi } from "../api";

interface WheelState {
  config: WheelConfig | null;
  isLoaded: boolean;
  loading: boolean;
}

export const useWheelStore = createWithEqualityFn<WheelState>()(() => ({
  config: null,
  isLoaded: false,
  loading: false,
}));

let loadingPromise: Promise<WheelConfig | null> | null = null;

/**
 * 加载转盘配置（带去重：已加载或加载中时不重复请求）
 */
export async function loadWheelConfig(): Promise<WheelConfig | null> {
  if (useWheelStore.getState().isLoaded) {
    return useWheelStore.getState().config;
  }
  if (loadingPromise) {
    return loadingPromise;
  }
  loadingPromise = (async () => {
    useWheelStore.setState({ loading: true });
    try {
      const config = await wheelApi.getConfig();
      useWheelStore.setState({ config, isLoaded: true, loading: false });
      return config;
    } catch (error) {
      // 静默失败：转盘入口属增强展示，请求失败不打扰用户
      consola.error("[wheel] 转盘配置加载失败:", error);
      useWheelStore.setState({ loading: false });
      return null;
    } finally {
      loadingPromise = null;
    }
  })();
  return loadingPromise;
}
